import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2)
  }
}));